makeErrorEnum = require 'lib/make-error-enum'
Plugin = require 'models/plugin'
PluginHandlers = require 'views/internal/plugins/plugin-handlers'
PluginIO = require 'views/internal/plugins/plugin-io'

PluginIOCacheError = makeErrorEnum 'PluginCache', [
  'InvalidArgument'
]

class PluginIOCache
  Error: PluginIOCacheError

  constructor: ->
    @pluginFromId = {}

  get: (plugin) ->
    if plugin !instanceof Plugin
      throw PluginIOCacheError.InvalidArgument("expected a plugin")

    id = plugin.id
    if (existingPlugin = @fromId(id))?
      return existingPlugin

    iframeConnectorUrl = plugin.get('iframeConnectorUrl')

    ownedByTrello = plugin.get('idOrganizationOwner') == window.firstPartyPluginsOrg
    isOnTrelloDomain = /^https:\/\/[\w-]+\.(?:staging\.)?trello\.services\//.test(iframeConnectorUrl)
    isOnButlerDomain = /^https:\/\/(?:app\.)?butlerfortrello\.com/.test(iframeConnectorUrl)
    # Only in the dev environment is the first party plugins org 000000000000000000000000
    # checking this lets us capture localhost dev usage but also ngrok usage
    isDevPluginsOrg = /^0{24}$/.test(window.firstPartyPluginsOrg)

    canUseRestrictedHandlers = ownedByTrello && (isOnTrelloDomain || isOnButlerDomain || isDevPluginsOrg)

    io = new PluginIO(
      plugin,
      PluginHandlers({
        idPlugin: id,
        allowRestricted: canUseRestrictedHandlers
      })
    )

    @pluginFromId[id] = io
    io

  fromId: (id) ->
    @pluginFromId[id]

  drop: (idPlugin) ->
    if (plugin = @pluginFromId[idPlugin])?
      delete @pluginFromId[idPlugin]
      plugin.drop()

module.exports = new PluginIOCache()



// WEBPACK FOOTER //
// ./app/scripts/views/internal/plugins/plugin-io-cache.coffee